import { Box, Text, Image, Center, Row } from 'native-base'

import { COINS_REWARD_VALUE } from '~constants'
import { useTranslation } from '~hooks'
import { Images } from '~images'

export const UpdatePointsRewardInfo = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Box
      bg={{
        linearGradient: {
          colors: ['actionBlue', 'actionBlue800'],
          start: [1, 0.4],
          end: [0.3, 0],
        },
      }}
      borderRadius="xl"
      py="4"
      px="5"
      mt="6"
      w="full"
    >
      <Row alignItems="center">
        <Center rounded="full" bg="white300" p="2" size="8">
          <Image source={Images.SYGNET} resizeMode="contain" size="full" alt="logo" />
        </Center>
        <Box ml="4">
          <Text color="white" fontSize="md" bold>
            {t('user_profile_screen.update_points_reward_title', { coins: COINS_REWARD_VALUE })}
          </Text>
          <Text color="white" opacity={0.9} fontSize="xs">
            {t('user_profile_screen.update_points_reward_info')}
          </Text>
        </Box>
      </Row>
    </Box>
  )
}
